import client from "./api";

export const pushSupported = () =>
  typeof navigator !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const raw = atob((base64String + padding).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export const currentPermission = () => (pushSupported() ? Notification.permission : "unsupported");

// Must be invoked from a user gesture (click). Never call automatically.
export async function enableBreakingAlerts() {
  if (!pushSupported()) throw new Error("unsupported");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return { enabled: false, permission };

  const registration = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  await navigator.serviceWorker.ready;

  const { data } = await client.get("/push/public-key");
  if (!data.publicKey) throw new Error("no-key");

  let sub = await registration.pushManager.getSubscription();
  if (!sub) {
    sub = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey),
    });
  }
  await client.post("/push/subscribe", sub.toJSON());
  return { enabled: true, permission };
}

export async function disableBreakingAlerts() {
  if (!pushSupported()) return;
  const registration = await navigator.serviceWorker.getRegistration();
  const sub = registration && (await registration.pushManager.getSubscription());
  if (sub) {
    await client.post("/push/unsubscribe", { endpoint: sub.endpoint }).catch(() => {});
    await sub.unsubscribe().catch(() => {});
  }
}
